/* Pulse 2.0: aggregate engagement only after affirmative CMP consent.
   No DOM replay, keystrokes, form values, raw query strings or precise location. */
(function(){
 'use strict';
 var stopCurrent=function(){};
 var uuid=function(v){return typeof v==='string'&&/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(v);};
 var sensitive=function(path){return /(?:checkout|payment|account|login|password|auth|cart)/i.test(path);};
 var cleanUrl=function(){var u=new URL(location.href);u.search='';u.hash='';return u.toString();};
 var clamp=function(v,max){return Math.min(max,Math.max(0,Number.isFinite(v)?v:0));};
 window.PulseTracker={
  start:function(options){
   if(!options||options.consent!==true||!options.token||!options.endpoint||sensitive(location.pathname)){stopCurrent();return false;}
   if(options.message&&!uuid(options.message)||options.profile&&!uuid(options.profile)){stopCurrent();return false;}
   stopCurrent();
   var key='pulse_attribution_'+options.token.split('_').slice(0,2).join('_'),now=Date.now(),cached=null;
   try{cached=JSON.parse(sessionStorage.getItem(key)||'null');}catch(_error){}
   if(!cached||cached.expires<=now||!uuid(cached.id)||!Number.isFinite(cached.started))cached=null;
   var params=new URL(location.href).searchParams;
   var landingMedium=(params.get('utm_medium')||'').trim().toLowerCase();
   var landingSource=(params.get('utm_source')||'').trim().toLowerCase();
   var explicitLandingMessage=uuid(params.get('pulse_message'))||uuid(options.message);
   // A new ambiguous provider link must never inherit an old email session.
   // Only check the presence of _kx; never read or persist its contents.
   if(landingMedium!=='email'&&!explicitLandingMessage&&
      (params.has('_kx')||['klaviyo','mailchimp','omnisend'].includes(landingSource)))cached=null;
   var tagged=params.get('pulse_message'),message=options.message||(uuid(tagged)?tagged:cached&&uuid(cached.message)?cached.message:null);
   var tag=params.get('pulse_element'),validTag=tag!==null&&/^(0|[1-9][0-9]{0,2})$/.test(tag);
   var element=message&&validTag?Number(tag):tag!==null?null:cached&&message===cached.message?cached.element??null:null;
   var medium=landingMedium;
   // _kx can identify Klaviyo visitors from both email and SMS. Presence of
   // _kx or utm_source alone is not evidence of an email channel.
   // Never read, copy or retain the opaque _kx value.
   var emailSource=medium==='email';
   function sourceId(value){
    if(!value||value.length>240)return null;
    var direct=/^[A-Za-z0-9_-]{4,80}$/.exec(value);
    if(direct)return direct[0];
    var suffix=/\(([A-Za-z0-9_-]{4,80})\)\s*$/.exec(value);
    return suffix?suffix[1]:null;
   }
   var idHint=emailSource?(sourceId(params.get('utm_id'))||sourceId(params.get('utm_campaign'))):null;
   var profile=options.profile||(cached&&uuid(cached.profile)?cached.profile:null);
   if(cached&&(cached.message!==message||cached.profile!==profile||(cached.element??null)!==element||(idHint&&cached.utmMessageId&&cached.utmMessageId!==idHint)))cached=null;
   var original=cleanUrl();
   var emailSourceProof=emailSource?'utm_email':message?'pulse_message':cached&&cached.emailSourceProof==='utm_email'?'utm_email':null;
   var emailHint=!!emailSourceProof;
   var state={id:cached?cached.id:crypto.randomUUID(),started:cached?cached.started:now,entry:cached&&cached.entry?cached.entry:original,
      path:cached&&cached.path?cached.path:location.pathname,message:message,element:element,profile:profile,emailHint:emailHint,emailSourceProof:emailSourceProof,utmMessageId:idHint||(cached&&cached.emailSourceProof==='utm_email'&&cached.utmMessageId)||null,
      scroll:cached?clamp(cached.scroll||0,1):0,engaged:cached?clamp(cached.engaged||0,86400):0,
      pages:cached?clamp(cached.pages||1,500):1,productViews:cached?clamp(cached.productViews||0,500):0,
      cartActions:cached?clamp(cached.cartActions||0,500):0,ctaActions:cached?clamp(cached.ctaActions||0,500):0,
      expires:now+1800000,lastActive:now};
   if(!cached&&/^\/products\//.test(location.pathname))state.productViews=1;
   var active=true,tickTimer=null,flushTimer=null;
   function persist(){try{sessionStorage.setItem(key,JSON.stringify(state));}catch(_error){}}
   function activity(){if(!active)return;if(state.expires<=Date.now()){stopCurrent();return;}state.lastActive=Date.now();state.expires=Date.now()+1800000;persist();}
   function route(){
    if(sensitive(location.pathname)){stopCurrent();return false;}
    if(state.path!==location.pathname){
     state.path=location.pathname;state.pages=clamp(state.pages+1,500);
     if(/^\/products\//.test(location.pathname))state.productViews=clamp(state.productViews+1,500);
     activity();
    }
    return true;
   }
   function measure(){
    var height=Math.max(1,document.documentElement.scrollHeight-innerHeight);
    state.scroll=Math.max(state.scroll,clamp(scrollY/height,1));
   }
   function scroll(){measure();activity();}
   function tick(){
    if(!active)return;
    if(state.expires<=Date.now()){stopCurrent();return;}
    if(document.visibilityState==='visible'&&(typeof document.hasFocus!=='function'||document.hasFocus())&&Date.now()-state.lastActive<=30000){
      state.engaged=clamp(state.engaged+1,86400);
    }
   }
   function intention(event){
    if(!active)return;
    var target=event.target;
    if(!target||typeof target.closest!=='function')return;
    var item=target.closest('[data-pulse-intent]');
    if(item){
     var intent=item.getAttribute('data-pulse-intent');
     if(intent==='primary_cta')state.ctaActions=clamp(state.ctaActions+1,500);
     if(intent==='add_to_cart')state.cartActions=clamp(state.cartActions+1,500);
    }
    activity();
   }
   function submit(event){
    var form=event.target;
    if(!active||!form||typeof form.getAttribute!=='function')return;
    var action=form.getAttribute('action')||'';
    if((/^\/?cart\/add(?:\.js)?(?:\?|$)/.test(action)||/\/cart\/add(?:\.js)?(?:\?|$)/.test(action))&&!(typeof form.querySelector==='function'&&form.querySelector('[data-pulse-intent="add_to_cart"]')))
     state.cartActions=clamp(state.cartActions+1,500);
    activity();
   }
   function flush(){
    if(!active)return;if(state.expires<=Date.now()){stopCurrent();return;}if(!route())return;
    measure();persist();
    // Entry is the first consented page, not the last SPA route.
    fetch(options.endpoint,{method:'POST',headers:{'Content-Type':'application/json','X-Pulse-Tracker':options.token},
      body:JSON.stringify({session:state.id,message:state.message,element:state.element,profile:state.profile,
       url:state.entry,scroll:state.scroll,duration:clamp(Math.floor((Date.now()-state.started)/1000),86400),
       engaged:state.engaged,pages:state.pages,productViews:state.productViews,cartActions:state.cartActions,ctaActions:state.ctaActions,
       emailHint:state.emailHint,...(state.utmMessageId?{utmMessageId:state.utmMessageId}:{}),consent:true}),credentials:'omit',keepalive:true}).catch(function(){});
   }
   function hide(){if(document.visibilityState==='hidden')flush();}
   function page(){route();}
   persist();
   addEventListener('scroll',scroll,{passive:true});
   addEventListener('pointerdown',activity,{passive:true});
   addEventListener('keydown',activity);
   addEventListener('popstate',page);
   addEventListener('pagehide',flush);
   document.addEventListener('click',intention,{passive:true});
   document.addEventListener('submit',submit,{passive:true});
   document.addEventListener('visibilitychange',hide);
   tickTimer=setInterval(tick,1000);flushTimer=setInterval(flush,15000);
   stopCurrent=function(){
    active=false;clearInterval(tickTimer);clearInterval(flushTimer);
    removeEventListener('scroll',scroll);removeEventListener('pointerdown',activity);removeEventListener('keydown',activity);
    removeEventListener('popstate',page);removeEventListener('pagehide',flush);
    document.removeEventListener('click',intention);document.removeEventListener('submit',submit);
    document.removeEventListener('visibilitychange',hide);
    try{sessionStorage.removeItem(key);}catch(_error){}
    stopCurrent=function(){};
   };
   if(typeof window.clarity==='function'&&message)window.clarity('set','pulse_message',message);
   return true;
  },
  stop:function(){stopCurrent();}
 };
})();
